import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-upload-item', 'remove', 'Tühista');
